import { Dispatch, SetStateAction, useState } from "react";

import { faArrowLeft, faArrowRight } from "@fortawesome/pro-regular-svg-icons";

import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { Button } from "@/components/Button/Button";
import { Icon } from "@/components";

import { ListPerson } from "../schema/list";

export const usePersonSlider = () => {
	const [currentPerson, setCurrentPerson] = useState<number>(0);

	const handlePreviousPerson = (
		setAiResult: Dispatch<SetStateAction<{ answer: string; sourceUrl: string } | undefined>>
	) => {
		if (currentPerson > 0) {
			setCurrentPerson(currentPerson - 1);
			setAiResult(undefined);
		}
	};

	const handleNextPerson = (
		setAiResult: Dispatch<SetStateAction<{ answer: string; sourceUrl: string } | undefined>>,
		inbox: ListPerson[]
	) => {
		if (inbox?.[currentPerson + 1]) {
			setCurrentPerson(currentPerson + 1);
			setAiResult(undefined);
		}
	};

	const renderPersonSlider = (
		setAiResult: Dispatch<SetStateAction<{ answer: string; sourceUrl: string } | undefined>>,
		inbox: ListPerson[]
	) => {
		return (
			<div className="mb-5 mt-5">
				<div className="flex flex-col grow mr-2 border-t border-gray-200 mb-2 pt-2">
					<div className="text-ssm font-medium">Currently selected person</div>
				</div>
				<div className="grow flex flex-col gap-2 items-start">
					<div className="flex flex-row text-sm items-center">
						<img
							className="h-[20px] w-auto mr-1 rounded-full"
							src={inbox[currentPerson]?.prospect?.image || ""}
						/>
						{inbox[currentPerson]?.prospect?.name}
						{inbox[currentPerson]?.prospect?.title
							? ` - ${inbox[currentPerson]?.prospect?.title}`
							: ""}
					</div>
					{inbox[currentPerson]?.prospect?.organization?.name && (
						<div className="flex text-sm flex-row items-center">
							{inbox[currentPerson]?.prospect?.organization?.logoUrl && (
								<img
									className="h-[20px] w-auto mr-1 rounded-full"
									src={inbox[currentPerson]?.prospect?.organization?.logoUrl || ""}
								/>
							)}
							{inbox[currentPerson]?.prospect?.organization?.name}
						</div>
					)}
				</div>
				<div className="flex flex-row pt-3">
					<div className="w-[180px] mr-2">
						<Button
							color={ButtonColor.ACTION_SECONDARY}
							disabled={currentPerson === 0}
							image={<Icon className="mr-2" icon={faArrowLeft} />}
							size={ButtonSize.S}
							title="Previous Person"
							onClick={() => handlePreviousPerson(setAiResult)}
						/>
					</div>
					<div className="w-[180px] ml-2">
						<Button
							color={ButtonColor.ACTION_SECONDARY}
							disabled={!inbox?.[currentPerson + 1]}
							iconRight={true}
							image={<Icon className="ml-2" icon={faArrowRight} />}
							size={ButtonSize.S}
							title="Next Person"
							onClick={() => handleNextPerson(setAiResult, inbox)}
						/>
					</div>
				</div>
			</div>
		);
	};

	return {
		handleNextPerson,
		currentPerson,
		setCurrentPerson,
		handlePreviousPerson,
		renderPersonSlider,
	};
};
